export const TRACKER_NAME = 'personalization-lib';